import { useEffect, useState } from "react";
import Navbar from "../../DashBoardComponents/Navbar";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import { IoVideocam } from "react-icons/io5";
import { FaCalendarAlt, FaUser } from "react-icons/fa";
import Footer from "../../DashBoardComponents/Footer";
import { message, Spin, Switch } from "antd";
import { useLocation } from "react-router-dom";
import { addMinutesToTime, convertUTCDate } from "../../utils/convertionFunc";
import dayjs from "dayjs";
import { patientPayment } from "../../utils/Appointments";
import { useSelector } from "react-redux";
import PatientService from "../../Services/PatientService";
import MembershipBg from "../../assets/membership/membershipbgImagecolour.svg";

const Checkout = () => {
  const [doctor, setDoctor] = useState(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();
  const { patientData } = useSelector((state) => state.auth);
  const [patientMembershipDet, setPatientMembershipDet] = useState(null);
  const [membershipAvailed, setMembershipAvalied] = useState(false);
  const [doctorDiscountAvailed, setDoctorDiscountAvailed] = useState(false);

  useEffect(() => {
    if (patientData?.patientId) {
      fetchMembershipDetails();
    }
  }, [patientData?.patientId]);

  const fetchMembershipDetails = async () => {
    const payload = {
      membershipCard: state?.appointmentPayload.selectedPatient.membershipCard,
      serviceCategory: "APPT",
    };

    try {
      const response = await PatientService.patientMembershipDet(payload);
      const apptMembership = response?.data?.data.find(
        (item) => item.serviceCategory === "APPT"
      );
      setPatientMembershipDet(apptMembership);
    } catch (e) {
      console.error(e);
    }
  };

  const getConsultFee = (appointmentType) => {
    if (!appointmentType || !doctor) return 0;
    if (appointmentType === "video") return doctor?.videoFee || 0;
    if (appointmentType === "inPerson") return doctor?.inpersonFee || 0;
    if (appointmentType === "homeVisit") return doctor?.homeVisitFee || 0;
    return 0;
  };

  const getDoctorDiscountAmount = (appointmentType) => {
    if (!appointmentType || !doctor) return 0;
    if (appointmentType === "video")
      return doctor?.videoConsultDiscountAmount || 0;
    if (appointmentType === "inPerson")
      return doctor?.inPersonDiscountAmount || 0;
    if (appointmentType === "homeVisit")
      return doctor?.homeVisitDiscountAmount || 0;
    return 0;
  };

  // Add this helper function to get doctor discount percentage
  const getDoctorDiscountPercentage = (appointmentType) => {
    if (!appointmentType || !doctor) return 0;
    if (appointmentType === "video")
      return doctor?.videoConsultDiscountPercentage || 0;
    if (appointmentType === "inPerson")
      return doctor?.inPersonDiscountPercentage || 0;
    if (appointmentType === "homeVisit")
      return doctor?.homeVisitDiscountPercentage || 0;
    return 0;
  };

  const calculateDiscountAmount = (itemAmt, membershipObj) => {
    if (!membershipObj) return 0;
    const currentPrice = itemAmt || 0;
    const discountAmount = Math.floor(
      currentPrice * ((membershipObj?.discountPercentage || 0) / 100)
    );
    return discountAmount;
  };

  const getTotalDiscount = () => {
    const consultFee = getConsultFee(
      state?.appointmentPayload?.consultationType
    );

    if (membershipAvailed && patientMembershipDet) {
      return calculateDiscountAmount(consultFee, patientMembershipDet);
    }

    if (doctorDiscountAvailed) {
      return getDoctorDiscountAmount(
        state?.appointmentPayload?.consultationType
      );
    }

    return 0;
  };

  const getFinalAmount = () => {
    const consultFee = getConsultFee(
      state?.appointmentPayload?.consultationType
    );
    const discount = getTotalDiscount();
    return Math.max(0, consultFee - discount);
  };

  const handleMembershipSelection = (value) => {
    setMembershipAvalied(value);
    if (value) {
      setDoctorDiscountAvailed(false);
    }
  };

  const handleDoctorDiscouunt = (value) => {
    setDoctorDiscountAvailed(value);
    if (value) {
      setMembershipAvalied(false);
    }
  };

  useEffect(() => {
    setDoctor(state?.appointmentPayload.selectedDoctor);
    setPatientDetails(state?.appointmentPayload.selectedPatient);
  }, [state]);

  const handleClick = async () => {
    setIsLoading(true);
    const type = state.appointmentPayload.consultationType;
    const consultFee = getConsultFee(type);
    const discount = getTotalDiscount();
    const finalAmount = getFinalAmount();

    const payload = {
      account_Id: doctor?.account_Id,
      appointmentDate: dayjs(state?.appointmentPayload.selectedDate).format(
        "MM/DD/YYYY"
      ),
      clinic_Id: doctor?.clinic_Id,
      consultationReason: state?.appointmentPayload.consReason,
      complaintCode: state?.appointmentPayload.complaintCode || "",
      createdBy: doctor?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      dob: patientDetails?.dob || "",
      email: patientDetails?.email,
      endTime: addMinutesToTime(state?.appointmentPayload.selectedSlot, 15),
      firstName: patientDetails?.firstName,
      gender: patientDetails?.gender,
      lastName: patientDetails?.lastName,
      meetingLink: "",
      mobile: patientDetails?.mobile,
      modifiedBy: doctor?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDetails?.patientId,
      patientRegFee: 0,
      patientRegFeeYN: "N",
      patientType: "E",
      paymentConsultation: "BC",
      paymentReceived: "N",
      paymentType: "Digital",
      salutation: "",
      serviceCode:
        type === "video"
          ? "APPT_VIDEO"
          : type === "inPerson"
            ? "APPT_INPERSON"
            : "APPT_HOMEVISIT",
      serviceName:
        type === "video"
          ? "Video Consultation"
          : type === "inPerson"
            ? "Inperson Consultation"
            : "Homevisit Consultation",
      specialityCode: doctor.specialityCode,
      startTime: state?.appointmentPayload.selectedSlot,
      status: -1,
      totalAmount: finalAmount,
      consultationFee: consultFee,
      discountAmount: discount,
      userId: doctor?.userId,
      referalId: state?.appointmentPayload?.referr || "",
    };

    payload.startTime = dayjs(payload.startTime, "HH:mm").format("hh:mm A");
    payload.endTime = dayjs(payload.endTime, "HH:mm").format("hh:mm A");

    if (membershipAvailed && patientMembershipDet) {
      payload.membershipCard = patientMembershipDet?.membershipCard;
      payload.membershipCode = patientMembershipDet?.membershipCode;
      payload.membershipDiscount = discount;
      payload.membershipName = patientMembershipDet?.membershipCode;
      payload.isMembershipDiscount = "Y";
    }

    if (doctorDiscountAvailed) {
      payload.isDoctorDiscount = "Y";
    }

    patientPayment(payload, doctor)
      .catch((error) => {
        console.error("An error occurred:", error);
        message.error("An Error occurred, try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Navbar />
      <div className="flex gap-6 p-6 bg-gray-50 min-h-screen mt-16">
        <div className="w-1/3 bg-white shadow-md rounded-lg p-4">
          {doctor?.imageName ? (
            <img
              src={process.env.REACT_APP_IMAGE_URL + doctor?.imageName}
              alt="DoctorPic"
              className="w-40 h-28 mx-auto rounded-sm object-contain"
            />
          ) : (
            <img
              src={doctorIcon}
              alt="DoctorPic"
              className="w-40 h-28 mx-auto rounded-sm"
            />
          )}
          <h2 className="text-xl font-bold mt-4 text-center text-[#346078]">
            {doctor?.userName}
          </h2>
          <hr className="text-[#346078]" />
          <div className="mt-6 rounded-md p-3 bg-[#F5F5F3]">
            <h3 className="text-base text-[#346078] font-semibold mb-2">
              Appointment Details
            </h3>
            <hr />
            {state.appointmentPayload.consultationType == "video" ? (
              <div className="flex gap-4 items-center text-gray-600 mb-1 mt-3">
                <IoVideocam className="text-[#346078]" />
                <p className="text-sm text-[#189FAA]">Video Consultation</p>
              </div>
            ) : state.appointmentPayload.consultationType == "inPerson" ? (
              <div className="flex gap-4 items-center text-gray-600 mb-1 mt-3">
                <FaUser className="text-[#346078]" />
                <p className="text-sm text-[#189FAA]">In-Person Consultation</p>
              </div>
            ) : (
              <div className="flex gap-4 items-center text-gray-600 mb-1 mt-3">
                <FaUser className="text-[#346078]" />
                <p className="text-sm text-[#189FAA]">Homevisit Consultation</p>
              </div>
            )}
            <div className="flex gap-4 items-center text-gray-600 nt-1">
              <FaCalendarAlt className="text-[#346078]" />
              <p className="text-sm text-[#189FAA]">
                {dayjs(state?.appointmentPayload.selectedDate).format(
                  "DD/MM/YYYY"
                )}
                ,
                {dayjs(state?.appointmentPayload.selectedSlot, "HH:mm").format(
                  "hh:mm A"
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 w-full bg-white shadow-md rounded-lg p-6">
          <div className="bg-blue-50 rounded-lg p-4">
            <h1 className="text-2xl font-semibold text-teal-600">Checkout</h1>
          </div>
          <div className="flex gap-2">
            {patientMembershipDet && (
              <div className="border w-[50%] border-gray-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "linear-gradient(to right, #e3f0f9, #d6e6ef)",
                    padding: "12px 16px",
                    borderBottom: "1px solid #e5e7eb",
                    backgroundImage: `url(${MembershipBg})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="flex justify-between items-start w-full">
                    <div className="flex items-start gap-3">
                      <div
                        className={`rounded-md p-0.5 bg-gradient-to-r ${patientMembershipDet?.membershipCode === "SINGLE"
                            ? "from-blue-400 to-blue-500"
                            : patientMembershipDet?.membershipCode === "TWIN"
                              ? "from-green-400 to-green-500"
                              : patientMembershipDet?.membershipCode === "FAMILY"
                                ? "from-cyan-400 to-cyan-500"
                                : "from-gray-400 to-gray-500"
                          }`}
                      >
                        <div className="bg-white rounded-md px-3 py-2">
                          <p className="text-sm font-semibold text-gray-800">
                            {patientMembershipDet?.membershipCode === "SINGLE"
                              ? "Single Member"
                              : patientMembershipDet?.membershipCode === "TWIN"
                                ? "Twin Members"
                                : patientMembershipDet?.membershipCode ===
                                  "FAMILY"
                                  ? "Family"
                                  : "Membership"}
                          </p>
                          <p className="text-xs text-gray-500">
                            Membership Plan
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <p className="text-base font-bold text-gray-800">
                        DOXZON
                      </p>
                      <p className="text-xs font-semibold text-gray-600">
                        Healthcare
                      </p>
                    </div>
                  </div>
                </div>

                {/* Card Body */}
                <div className="p-4 space-y-3">
                  <div>
                    <p className="text-2xl font-bold text-green-600">
                      Save INR
                      {calculateDiscountAmount(
                        getConsultFee(
                          state?.appointmentPayload?.consultationType
                        ),
                        patientMembershipDet
                      )}
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      Get{" "}
                      <span className="font-semibold">
                        {patientMembershipDet?.discountPercentage}%
                      </span>{" "}
                      off on consultation
                    </p>
                  </div>

                  <div className="flex justify-between items-center pt-2">
                    <label className="text-sm font-medium text-gray-700">
                      Apply membership discount
                    </label>
                    <Switch
                      value={membershipAvailed}
                      onChange={handleMembershipSelection}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Doctor Discount Card - Only show if discount is available for selected consultation */}
            {doctor &&
              getDoctorDiscountPercentage(
                state?.appointmentPayload?.consultationType
              ) > 0 && (
                <div className="border w-[50%] border-gray-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                  {/* Card Header */}
                  <div className="bg-gradient-to-r from-yellow-100 to-orange-50 p-4 border-b border-gray-200">
                    <div className="flex justify-between items-start">
                      <div className="flex items-start gap-3">
                        <div className="rounded-md p-0.5 bg-gradient-to-r from-red-400 to-pink-500">
                          <div className="bg-white rounded-md px-3 py-2">
                            <p className="text-sm font-semibold text-gray-800">
                              Special
                            </p>
                            <p className="text-xs text-gray-500">
                              Discount Offer
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-base font-bold text-gray-800">
                          DOXZON
                        </p>
                        <p className="text-xs font-semibold text-gray-600">
                          Healthcare
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Card Body */}
                  <div className="p-4 space-y-3">
                    <div>
                      <p className="text-2xl font-bold text-red-600">
                        Save INR
                        {getDoctorDiscountAmount(
                          state?.appointmentPayload?.consultationType
                        )}
                      </p>
                      <p className="text-sm text-gray-600 mt-1">
                        Get{" "}
                        <span className="font-semibold">
                          {getDoctorDiscountPercentage(
                            state?.appointmentPayload?.consultationType
                          )}
                          %
                        </span>{" "}
                        off on consultation
                      </p>
                    </div>

                    <div className="flex justify-between items-center pt-2">
                      <label className="text-sm font-medium text-gray-700">
                        Apply Special discount
                      </label>
                      <Switch
                        value={doctorDiscountAvailed}
                        onChange={handleDoctorDiscouunt}
                      />
                    </div>
                  </div>
                </div>
              )}

            {/* No Discounts Message */}
            {!patientMembershipDet && !doctor && (
              <div className="border border-gray-200 rounded-lg p-4 bg-gray-50 text-center">
                <p className="text-gray-500 text-sm">No discounts available</p>
              </div>
            )}
          </div>
          <div className="flex-1 space-y-6">
            <div>
              <p className="text-lg font-semibold uppercase text-teal-600 mb-3">
                Total Charges
              </p>
              <hr className="border-gray-200" />

              <div className="bg-gray-50 p-4 rounded-lg mt-4 space-y-3">
                <div className="flex justify-between items-center">
                  <p className="text-teal-600 font-medium">Consultation Fee</p>
                  <p className="text-teal-600 font-medium">
                    INR
                    {getConsultFee(state?.appointmentPayload?.consultationType)}
                  </p>
                </div>

                <div className="flex justify-between items-center">
                  <p className="text-teal-600 font-medium">Discount</p>
                  <p className="text-teal-600 font-medium">
                    - INR{getTotalDiscount()}
                  </p>
                </div>

                <hr className="border-gray-300" />

                <div className="flex justify-between items-center pt-2">
                  <p className="text-teal-600 font-bold text-lg">To Pay</p>
                  <p className="text-teal-600 font-bold text-lg">
                    INR{getFinalAmount()}
                  </p>
                </div>
              </div>

              {/* Pay Button */}
              <div className="flex justify-center mt-6">
                <button
                  disabled={isLoading}
                  className="w-full lg:w-3/5 bg-teal-600 hover:bg-teal-700 text-white py-3 px-4 rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  onClick={handleClick}
                >
                  {isLoading ? (
                    <>
                      <Spin size="small" /> Processing...
                    </>
                  ) : (
                    `Pay INR${getFinalAmount()}`
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
